import React, { useState } from "react";
import { Stack, Typography, Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { useGetCustomerDetailsById } from "../../hooks";
import { EmptyGeneral } from "../../svgs";
import { CustomerContactsTable } from "../../tables";
import { EditCustomerContact } from "../../dialogs";
import { DialogButton, HubButton } from "../../components";

const CustomerContacts = ({ hideBar = false }) => {
  const { id } = useParams();
  const { data } = useGetCustomerDetailsById(id);

  const contacts = data?.contacts || [];
  const customerId = data?.id;
  const count = contacts.length;

  const [contact, setContact] = useState({});
  const [isUpdate, setIsUpdate] = useState(false);

  const handleCreateContact = () => {
    setIsUpdate(false);
    setContact({});
  };

  const handleEditContact = (e, contact) => {
    setIsUpdate(true);
    setContact(contact);
    const button = document.getElementById("EditContact");
    button?.click();
  };

  return (
    <>
      {count ? (
        <Stack gap="25px">
          <CustomerContactsTable
            contacts={contacts}
            onRowClick={handleEditContact}
          />
          <DialogButton
            id="EditContact"
            name="edit-contact"
            label=""
            sx={{ display: "none" }}
          />
        </Stack>
      ) : (
        <Stack gap="25px" margin="auto" alignItems="center">
          <Box component="img" src={EmptyGeneral} sx={{ height: "150px" }} />
          <Stack gap="10px" alignItems="center" textAlign="center">
            <Typography variant="boldCaption">No Contacts Found</Typography>
            <Typography variant="caption" width="250px">
              Click "Create Contact" button to get started in adding this
              customer's contact information
            </Typography>
            <Stack direction="row" gap="10px">
              <HubButton
                variant="outlined"
                size="small"
                color="neutral"
                label="Learn More"
              />
              <DialogButton
                id="EditContact"
                name="edit-contact"
                label="Create Contact"
                onClick={handleCreateContact}
                variant="contained"
                size="xsmall"
              />
            </Stack>
          </Stack>
        </Stack>
      )}
      <EditCustomerContact
        contact={contact}
        isUpdate={isUpdate}
        customerId={customerId}
      />
    </>
  );
};

export { CustomerContacts };
export default CustomerContacts;
